"use client"

import { getPublicImagePath, STATIC_IMAGES } from "@/app/config/images"
import Prose from "@/components/ui/Prose"
import Image from "next/image"

export default function HomeHero() {
  return (
    <section className="relative overflow-hidden min-h-[200px] md:min-h-[280px]">
      {/* Hero background image - optimized with next/image for LCP */}
      <Image
        src={getPublicImagePath(STATIC_IMAGES.HOME_FEATURED_IMAGE)}
        alt=""
        fill
        priority
        fetchPriority="high"
        sizes="100vw"
        className="object-cover object-left"
        style={{ objectPosition: "left 25%" }}
        quality={75}
      />
      {/* Overlay pour améliorer la lisibilité du texte */}
      <div className="absolute inset-0 bg-background/80" />
      <div className="container mx-auto relative px-4 py-6 md:py-20 z-10">
        <div className="lg:flex lg:items-center lg:justify-between lg:gap-16">
          <div className="space-y-2 max-w-lg lg:max-w-2xl">
            <h1 className="text-xl font-extrabold tracking-tighter sm:text-2xl md:text-3xl flex-1 drop-shadow-lg">
            <span className="opacity-70">UIC Rail</span> Sustainability <span className="text-lime-500">Hub</span>
            </h1>

            <div className="lg:columns-2 lg:gap-4">
              <Prose
                content="The Rail Sustainability Hub is a collaborative platform dedicated to advancing sustainable practices across the global rail sector. Designed for and by members of the UIC, this library showcases a growing collection of practical solutions, proven best practices, and lessons learned from real-world implementation. As a collective knowledge-sharing hub, it empowers railway professionals to contribute, explore, and apply innovative approaches to reduce environmental impact and enhance sustainability throughout the industry. Search the library and create an account today to share your work with the global network."
                className="text-sm opacity-80 tracking-tighter drop-shadow-md"
                proseSize="sm"
                textWrapMode="pretty"
                hyphenation={true}
                textAlign="left"
                readMore={true}
                maxLength={1000}
              />
            </div>
          </div>
          <div className="text-right hidden lg:block">
            <Image
              src={getPublicImagePath(
                process.env.NEXT_PUBLIC_APP_LOGO_FILE || ""
              )}
              alt="UIC, the International Union of Railways"
              width={200}
              height={150}
              className="h-30 w-auto text-right drop-shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
